// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3i6-h","modalForm":"UpgradeEpcsModal_modalForm__2Xx--","modalFooter":"UpgradeEpcsModal_modalFooter__3ERdl"};